import AdminSidebar from "../components/AdminSidebar/AdminSidebar";
// import Navbar from "../components/Navbar/Navbar";
import Loader from "../components/Loader/Loader";
import { useEffect, useState } from "react";

import "./AdminLayout.css";

export default function AdminLayout({ children }) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1200);
  }, []);

  if (loading) {
    return <Loader />;
  }
  return (
    <div className="dashboard1">
      <AdminSidebar />

      <div className="main-content1">
        {/* <Navbar /> */}

        <div className="page-transition1">{children}</div>
        <footer className="app-footer1">Powered By NN FIT | © 2026</footer>
      </div>
    </div>
  );
}
